/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerButtonIcon16Light = forwardRef('TechPowerButtonIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6Z" }),
        React.createElement("path", { d: "M4.298 3.028a.5.5 0 0 0-.582-.813 6.5 6.5 0 1 0 7.575.005.5.5 0 0 0-.583.812 5.5 5.5 0 1 1-6.41-.004Z" })));
});
